import React from "react";
import { Helmet } from "react-helmet";
import favicon from "../assets/images/favicon.png";

const JeenaHead = () => {
  return (
    <Helmet>
      {/* Required meta tags */}
      <meta charSet="utf-8" />
      <meta name="description" content="" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      {/* Title */}
      <title>SOURCE OF SURGICAL | Instruments Sourcing Partner</title>
      {/* Favicon Icon */}
      <link rel="shortcut icon" href={favicon} type="image/x-icon" />
    </Helmet>
  );
};

export default JeenaHead;
